export default __webpack_public_path__ + "f1c3b9d814987d6590c928c2db545831.svg";